import './App.css';
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import AboutUs from "./components/AboutUs/AboutUs";
import Navbar from "./components/Navbar/Navbar";
import AnnouncementsPage from "./components//Announcements/Announcements";
import LanguageProvider from "./context/LanguageContext";
import AnnouncementDetails from "./components/Announcements/AnnouncementDetails/AnnouncementDetails";
import Footer from "./components/Footer/Footer";
import Vision from './components/Vision/Vision';
import Companies from './components/Companies/Companies';
import BoardOfDirectors from './components/BoardOfDirectors/BoardOfDirectors';
import Investments from './components/Investments/Investments';
import Contact from './components/Contact/Contact';
import RedirectPage from './components/RedirectPage/RedirectPage';

function AppWrapper() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to="/about" />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/announcements" element={<AnnouncementsPage />} />
        <Route path="/announcements/:slug" element={<AnnouncementDetails />} />
        <Route path="/vision" element={<Vision />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/board" element={<BoardOfDirectors />} />
        <Route path="/investments" element={<Investments />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/r" element={<RedirectPage />} />
        <Route path="*" element={<Navigate to="/about" />} />

        <Route path="/ar" element={<Navigate to="/" replace />} />
        <Route path="/en" element={<Navigate to="/" replace />} />

      </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <AppWrapper />
      </Router>
    </LanguageProvider>
  );
}

export default App;
